/**
 * GraphQL queries for community prompts
 */

import { gql } from '@apollo/client';

export const GET_COMMUNITY_PROMPTS = gql`
  query GetCommunityPrompts($communityId: ID!) {
    communityPrompts(communityId: $communityId) {
      id
      type
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
      availablePromptVersions {
        classification
        moderation
      }
      prodPromptVersion {
        classification
        moderation
      }
    }
  }
`;
